/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const state = {
  instrumen: null,
};

export const mutations = {
  SET_INSTRUMEN(state, newValue) {
    state.instrumen = newValue;
  },
};

export const actions = {
  async fetch({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const { data } = await http.get(`/psp/i/${id}/kinerja?${queryString(payload.params)}`);
    return data;
  },

  async getInstrumen({ rootState, state, commit }) {
    if (state.instrumen) {
      return state.instrumen;
    }

    const id = rootState.auth.instansi_id;
    const data = await http.get(`/psp/i/${id}/kinerja/instrumen`).then(({ data }) => data);
    commit('SET_INSTRUMEN', data);

    return data;
  },

  async getDetail({ rootState }, payload) {
    if (!payload.id) {
      return {};
    }

    const id = rootState.auth.instansi_id;
    return await http.get(`/psp/i/${id}/kinerja/${payload.id}/fetch`).then(({ data }) => data);
  },

  update({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/kinerja/save/${payload.id}`;

    return http.post(url, payload.params);
  },
};
